import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Avatar, Stack, Tab, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { InspectionIcon } from 'app/icons';
import { ChecklistTemplateForm, ChecklistTemplateHistoryList } from 'app/pages/Checklist';
import ChecklistTemplateAutocolonList from 'app/pages/Checklist/ChecklistTemplateAutocolonList';
import { useAsyncAction } from 'app/services';
import { templateDataLoad, templateUpdate } from 'app/store/checklist';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
const ChecklistTemplateView = () => {
    const formRef = useRef(null);
    const { templateSelectedItem } = useSelector((state) => state.checklist);
    const [tab, setTab] = useState('info');
    const { asyncAction: fetchData, isLoading: isFetchDataLoading } = useAsyncAction(templateDataLoad, [templateSelectedItem]);
    const { asyncAction: updateSubmit, isLoading: isUpdateLoading, isSuccessful: isUpdateSuccessful, isError: isUpdateError, } = useAsyncAction(templateUpdate, [templateSelectedItem]);
    useEffect(() => {
        if (!templateSelectedItem)
            return;
        switch (tab) {
            case 'history':
                !isFetchDataLoading && fetchData(templateSelectedItem.id);
                break;
        }
    }, [tab, templateSelectedItem]);
    const handleFormSubmit = (params) => {
        updateSubmit(params);
    };
    return (React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: {
            height: '100%',
            flex: '1 1 auto',
            '.simplebar-content': {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            },
        } },
        templateSelectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                maxWidth: '540px',
                width: '100%',
                height: tab === 'history' ? '100%' : 'auto',
                padding: theme.spacing(2),
            }) },
            React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                    marginBottom: theme.spacing(3),
                    '.MuiAvatar-root': {
                        width: '56px',
                        height: '56px',
                        bgcolor: theme.palette.primary.main,
                    },
                    '.MuiAvatar-circular': {
                        color: theme.palette.primary.main,
                        bgcolor: alpha(theme.palette.primary.main, 0.12),
                        svg: {
                            width: '30px',
                            height: '30px',
                        },
                        path: {
                            fill: theme.palette.primary.main,
                        },
                    },
                    '.MuiTypography-root:first-of-type': {
                        marginTop: theme.spacing(1),
                    },
                }) },
                React.createElement(Avatar, null,
                    React.createElement(InspectionIcon, { fontSize: 'large' })),
                React.createElement(Typography, { variant: 'body1' }, templateSelectedItem.name)),
            React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                    width: '100%',
                    height: tab === 'history' ? '100%' : 'auto',
                    position: 'relative',
                    border: '1px solid',
                    borderRadius: theme.shape.borderRadius,
                    borderColor: theme.palette.divider,
                    bgcolor: 'background.paper',
                    '.MuiTabPanel-root': {
                        width: '100%',
                        padding: theme.spacing(2),
                    },
                }) },
                React.createElement(TabContext, { value: tab },
                    React.createElement(TabList, { onChange: (event, value) => setTab(value), TabIndicatorProps: { children: React.createElement("span", null) }, sx: (theme) => ({
                            width: '100%',
                            minHeight: '44px',
                            borderBottom: '1px solid',
                            borderColor: theme.palette.divider,
                            '.MuiTab-root': {
                                fontSize: '12px',
                                minHeight: '44px',
                                padding: theme.spacing(2),
                                '&.Mui-selected': {
                                    color: 'inherit',
                                },
                            },
                            '.MuiTabs-indicator': {
                                display: 'flex',
                                justifyContent: 'center',
                                backgroundColor: 'transparent',
                            },
                            '.MuiTabs-indicator span': {
                                width: 'calc(100% - ' + theme.spacing(4) + ')',
                                bgcolor: theme.palette.primary.main,
                                borderRadius: theme.shape.borderRadius,
                            },
                        }) },
                        React.createElement(Tab, { value: 'info', label: '\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F', disableRipple: true }),
                        React.createElement(Tab, { value: 'history', label: '\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439', disableRipple: true }),
                        React.createElement(Tab, { value: 'autocolon', label: '\u0410\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B', disableRipple: true })),
                    React.createElement(TabPanel, { value: 'info' },
                        React.createElement(ChecklistTemplateForm, { ref: formRef, defaultValues: templateSelectedItem, onSubmit: handleFormSubmit }),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                '.MuiAlert-root': {
                                    width: '100%',
                                    marginTop: theme.spacing(2),
                                    borderRadius: theme.shape.borderRadius,
                                },
                            }) },
                            !isUpdateSuccessful && isUpdateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                            isUpdateSuccessful && !isUpdateError && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                paddingTop: theme.spacing(3),
                            }) },
                            React.createElement(LoadingButton, { variant: 'contained', loading: isUpdateLoading, onClick: () => { var _a; return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit(); }, disableElevation: true }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"))),
                    React.createElement(TabPanel, { value: 'history', style: { height: '100%', padding: '0' } },
                        React.createElement(ChecklistTemplateHistoryList, null)),
                    React.createElement(TabPanel, { value: 'autocolon', style: { height: '100%', padding: '0' } },
                        React.createElement(ChecklistTemplateAutocolonList, null)))))),
        !templateSelectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                height: '100%',
                padding: theme.spacing(0, 2),
                '.MuiTypography-root': {
                    borderRadius: '20px',
                    marginTop: '24px',
                    padding: theme.spacing(0.5, 2),
                    bgcolor: alpha(theme.palette.grey.main, 0.12),
                },
            }) },
            React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430")))));
};
export default ChecklistTemplateView;
